
import main from "./main.js"
import simbol from "./simbol.js"

export default {
    ...main,
    ...simbol
}